// Application constants
export const SOCKET_URL = "https://broadcast.frebsongym.com";
export const MODAL_TIMEOUT = 5000;

export const EXCLUDED_ROUTES = [
  "/login",
  "/request-otp",
  "/input-otp",
  "/reset-password",
];

export const IMAGES = {
  THUMBS_UP: "/images/thumbs-up.png",
  DELETE_DANGER: "/images/delete-danger.png",
  DEFAULT_AVATAR: "/images/settings-avatar.png",
};

export const MODAL_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
};
